const createRuleCreator = ruleName => (options = {}) => ({
    ...options,
    type: ruleName
});

export const required = createRuleCreator('required');

export const number = createRuleCreator('number');

export const int = createRuleCreator('int');

export const positive = createRuleCreator('positive');

export const negative = createRuleCreator('negative');

export const money = createRuleCreator('money');

export const length = createRuleCreator('length');

export const range = createRuleCreator('range');

export const regexp = createRuleCreator('regexp');

export const email = createRuleCreator('email');

export const oneOf = createRuleCreator('oneOf');

export const oneOfBy = createRuleCreator('oneOfBy');

export const ascending = createRuleCreator('ascending');

export const equal = createRuleCreator('equal');

export const notEqual = createRuleCreator('notEqual');

export const confirm = createRuleCreator('confirm');

export const fn = createRuleCreator('fn');

export const func = createRuleCreator('func');

export const exclusion = createRuleCreator('exclusion');
